import React, {useEffect, useState} from 'react'
import {PatientInfoType} from './types/patientDataType'
import './appointment.css'
import useApi from '../../../../../../hooks/useQuery'
import {
  CREATE_APPOINTMENT,
  CREATE_APPOINTMENT_FROM_CONSUMER_SIDE,
  GET_SCAN_FEE,
} from '../../../GraphQLQueries/ProductOffering'
import useMutationApi from '../../../../../../hooks/useMutation'
import {LoadingSpinner} from '../../../../../../_ePulse/layout/components/LoadingSpinner'
import {ToastMessageContainer} from '../../../../../../_ePulse/layout/components/ToastMessageContainer'
import {toast} from 'react-toastify'
import {useNavigate} from 'react-router-dom'
import { da } from 'date-fns/locale'
const ConfirmAppointment: React.FC<{
  id?: string //consumer side appointment id
  patientInfo: PatientInfoType
  appointmentType: string
  NetAmount: number
  testDetails: any[]
  product: any
  isConsumerAppointment?: boolean
  againSeledtSlot: () => void
  dateTime: {
    appointmentStartTime: string
    appointmentEndTime: string
    labRoomName: string
    labRoomId: string
    holdTimeSlot: string
  }
  onAppointmentSuccess?: (pdfUrl: string) => void
}> = ({
  patientInfo,
  id, //
  appointmentType,
  NetAmount,
  testDetails,
  dateTime,
  product,
  againSeledtSlot,
  isConsumerAppointment,
  onAppointmentSuccess,
}) => {
  const navigate = useNavigate()

  console.log(dateTime , 'dateTime in confirm component')
  console.log(typeof dateTime.holdTimeSlot, 'type of hold time slot')

  const filterOption = [
    {
      id: 1,
      value: 'Paid',
      title: 'Paid',
    },
    {
      id: 2,
      value: 'PartiallyPaid',
      title: 'PartiallyPaid',
    },
  ]

  const [isOpen, setIsOpen] = useState<boolean>(false)
const [expiryTime, setExpiryTime] = useState<number | null>(null)
const [timeLeft, setTimeLeft] = useState<number>(0)
const [isExpired, setIsExpired] = useState(false)

  const [cashIn, setCashIn] = useState<number>(0)
  const [paymentType, setPaymentType] = useState('Paid')
  const [scanFeeData, setScanFeeData] = useState<any>(null)

  const [payableAmount, setPayableAmout] = useState<any>(null)
  const [amount, setAmount] = useState({
    outstandingAmount: 0,
    cashOut: 0,
    transactionAmount: 0,
  })
  const [templateSetting, setTemplateSetting] = useState({
    templateSize: `A4`,
    templateOrientation: `portrait`,
  })

  const {loading, error, data} = useApi('', GET_SCAN_FEE, {})
  const {
    createData,
    loading: CALoading,
    error: CAError,
    data: CAData,
  } = useMutationApi(CREATE_APPOINTMENT)

  const {
    createData: createConsumerAppt,
    loading: consumerLoading,
    error: consumerError,
    data: consumerData,
  } = useMutationApi(CREATE_APPOINTMENT_FROM_CONSUMER_SIDE)

  useEffect(() => {
  if (!dateTime?.holdTimeSlot || isConsumerAppointment) return

  const minutes = Number(dateTime.holdTimeSlot)
  if (isNaN(minutes)) return

  const expiry = Date.now() + minutes * 60 * 1000
  setExpiryTime(expiry)
  setIsExpired(false)
}, [dateTime.holdTimeSlot])

useEffect(() => {
  if (!expiryTime || isConsumerAppointment) return

  const interval = setInterval(() => {
    const remaining = Math.floor((expiryTime - Date.now()) / 1000)

    if (remaining <= 0) {
      clearInterval(interval)
      setTimeLeft(0)
      setIsExpired(true)
    } else {
      setTimeLeft(remaining)
    }
  }, 1000)

  return () => clearInterval(interval)
}, [expiryTime, isConsumerAppointment])

  const formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60)
    const secs = seconds % 60
    return `${mins}:${secs < 10 ? '0' : ''}${secs}`
  }

  useEffect(() => {
    if (paymentType === 'Paid') {
      setCashIn(payableAmount)
      setAmount({
        ...amount,
        cashOut: 0,
        transactionAmount: payableAmount,
        outstandingAmount: 0,
      })
    } else {
      let outstandingAmount = NetAmount - cashIn
      let cashOutAmt = 0
      if (cashIn > NetAmount) {
        cashOutAmt = cashIn - NetAmount
        outstandingAmount = 0
      }
      setAmount({
        ...amount,
        cashOut: parseFloat(cashOutAmt?.toFixed(2)),
        transactionAmount: cashIn,
        outstandingAmount: parseFloat(outstandingAmount?.toFixed(2)),
      })
    }
  }, [paymentType, cashIn, payableAmount])

  useEffect(() => {
    if (data) {
      setScanFeeData(data.getBusinessScanFee)
      const scanData = data.getBusinessScanFee
      console.log('call final amount calculation ')
      finalAmount(scanData)
    }
  }, [data])

  useEffect(() => {
    if (CAData || consumerData) {
      const pdfUrl = CAData
        ? CAData.createDiagnosisAppointment.receiptUrl
        : consumerData.createDiagnosisAppointmentV2.receiptUrl
      if (pdfUrl && onAppointmentSuccess) {
        onAppointmentSuccess(pdfUrl)
      }
    }
  }, [CAData, consumerData])

  const finalAmount = (data: any) => {
    const platFormFees = isConsumerAppointment ? 0 : Number(data?.platformFees || 0)
    const bookingCharges = isConsumerAppointment ? 0 : Number(data?.bookingCharges || 0)
    console.log('set Payable amount ')
    setPayableAmout(NetAmount + platFormFees + bookingCharges)
  }

  function formatIsoToCustom(iso: string): string {
    // Parse into a Date
    const d = new Date(iso)

    // Extract UTC fields
    const day = String(d.getUTCDate()).padStart(2, '0')
    const month = String(d.getUTCMonth() + 1).padStart(2, '0') // months are 0-11
    const year = d.getUTCFullYear()

    const hours = String(d.getUTCHours()).padStart(2, '0')
    const mins = String(d.getUTCMinutes()).padStart(2, '0')

    return `${day}-${month}-${year}, ${hours}.${mins}`
  }

  const handleCreateAppointmentApiCall = async () => {
    console.log('product--->> ', product)
    const testDetail: any = []
    testDetails.map((item: any, index: any) => {
      const newItem = {
        testGroupName: item.groupName,
        testGroupId: item.testGroupId,
        testName: item.testName,
        testNameId: item.id,
        price: item.testCost,
      }
      testDetail.push(newItem)
    })

    const platformFees = isConsumerAppointment ? 0 : scanFeeData.platformFees
    const bookingCharges = isConsumerAppointment ? 0 : scanFeeData.bookingCharges

    const appointmentInput = {
      patientId: patientInfo.patientId,
      patientName: patientInfo.patientName,
      patientMobileNumber: patientInfo.patientNumber,

      // appointmentType: appointmentType,
      appointmentStartTime: dateTime.appointmentStartTime,
      appointmentEndTime: dateTime.appointmentEndTime,
      gender: patientInfo.patientGender,
      labRoomId: dateTime.labRoomId,
      labRoomName: dateTime.labRoomName,
      //     //appointmentMode:"Home",
      paymentStatus:
        parseFloat(amount.outstandingAmount.toString()) > 0
          ? filterOption[1].value
          : filterOption[0].value,
      netAmount: parseFloat(NetAmount + platformFees + bookingCharges),
      //     // discountAmount: 100,
      //     // totalGstAmount: 180,
      totalAmount: parseFloat(NetAmount + platformFees + bookingCharges),
      paymentMode: 'DiagnosisCenter',
      cashIn: cashIn,
      cashOut: parseFloat(amount.cashOut.toString()),
      outstandingAmount: parseFloat(amount.outstandingAmount.toString()),
      transactionAmount: amount.transactionAmount,
      testProductType: product.productValue,
      testProductId: product.productId,
      homeVisitCharge: scanFeeData.homeVisitCharges,
      scanTestDetails: testDetail,
      ...(patientInfo.doctorName && {
        doctorName: patientInfo.doctorName,
        doctorMobileNumber: patientInfo.doctorNumber,
        specialty: patientInfo.specialty,
        doctorId: patientInfo.doctorId,
      }),
    }

    try {
      console.log(id, 'final check before api call')
      isConsumerAppointment
        ? await createConsumerAppt({id, appointmentInput})
        : await createData({appointmentInput})
      toast.success('Appointment Created Successfull!')
    } catch (error) {}

    // await createScanAppointment({
    //   variables: { appointmentInput: appointmentInput,isDoctorAppointment:props?.route?.params?.isDoctorAppointment },
    //   onCompleted: async (scanAppointmentData) => {
    //     setIsLoading(false)
    //     await clearStore("RouteID");
    //     await clearStore("TestNames");
    //     await clearStore("TestListData");
    //     let businessAddressData = await scanAppointmentData
    //       ?.createDiagnosisAppointment?.businessAddress;
    //     let businessPhoneNumber = await scanAppointmentData
    //       ?.createDiagnosisAppointment?.businessPhone;
    //     let businessName = await scanAppointmentData?.createDiagnosisAppointment
    //       ?.businessName;
    //     let receiptNo = await scanAppointmentData?.createDiagnosisAppointment
    //       ?.receiptNo;
    //     let receiptUrl = await scanAppointmentData?.createDiagnosisAppointment
    //       ?.receiptUrl;
    //     navigateScreen(navigation, S_ScanCreateReceipt, {
    //       appointmentInput: appointmentInput,
    //       createAppointmentDate: moment(new Date()).format("DD/MM/YYYY"),
    //       createAppointmentTime: moment(new Date()).format("HH:mm a"),
    //       businessAddress: businessAddressData,
    //       businessName: businessName,
    //       businessPhoneNumber: businessPhoneNumber,
    //       receiptNo: receiptNo,
    //       receiptUrl: receiptUrl,
    //       serviceType: serviceType,
    //     });
    //   },
    //   onError: (error) => {
    //     setIsLoading(false)
    //     setModalVisibleOne({
    //       title: "Error",
    //       key: JSON.stringify(error?.message),
    //       value: true,
    //     });
    //   },
    // });
    // }
  }

  return (
    <div className=''>
      <div className='d-flex justify-content-between align-items-center mb-4'>
        <h4 className='mb-4 fw-bold'>Confirm Appointment</h4>
        {!isConsumerAppointment && (
          <div style={{padding: '10px 20px', color: isExpired ? 'red' : '#333'}}>
            <strong>
              {isExpired
                ? <div>
                  <p>Session expired. Restart Booking</p>
                  {/* <button className='btn btn-primary' onClick={() => {
                    console.log('Select Again button clicked');
                    againSeledtSlot();
                  }}>Select Again</button> */}
                </div> 

                : <div> Holding Slot Time:
                  <span style={{color:'red'}}> {formatTime(timeLeft)}</span></div>}
            </strong>
          </div>
        )}
      </div>

      <LoadingSpinner isLoading={CALoading || loading || consumerLoading} />
      <div>
        <ToastMessageContainer />
      </div>
      <div className='d-flex' style={{marginBottom: '40px',gap: '40px'}}>
        <div className='d-flex flex-column  details-breakup'>
          <p className='details-text'>Details</p>
          <div className='d-flex justify-content-between align-items-center mb-2'>
            <label className='form-label fw-bold'>Patient Name</label>
            <p className='amt-val'>{patientInfo.patientName}</p>
          </div>
          <div className='d-flex justify-content-between align-items-center mb-2'>
            <label className='form-label fw-bold'>Patient Number</label>
            <p className='amt-val'>{patientInfo.patientNumber}</p>
          </div>
          <div className='d-flex justify-content-between align-items-center mb-2'>
            <label className='form-label fw-bold'>Doctor Name</label>
            <p className='amt-val'>{patientInfo.doctorName?patientInfo.doctorName:"N/A"} </p>
          </div>
          <div className='d-flex justify-content-between align-items-center mb-2'>
            <label className='form-label fw-bold'>Doctor Number</label>
            <p className='amt-val'>{patientInfo.doctorNumber?patientInfo.doctorNumber:"N/A"} </p>
          </div>

          <div className='d-flex justify-content-between align-items-center mb-2'>
            <label className='form-label fw-bold'>Appointment Type</label>
            <p className='amt-val'>{'At Diagnostic Center'} </p>
          </div>
          <div className='d-flex justify-content-between align-items-center mb-2'>
            <label className='form-label fw-bold'>Date & Time</label>
            <p className='amt-val'>{formatIsoToCustom(dateTime.appointmentStartTime)} </p>
          </div>
        </div>

        {/*Bill details */}
        <div className='d-flex flex-column  bill-breakup'>
          <p className='bill-text'>Amount</p>
          <div className='d-flex justify-content-between align-items-center mb-2'>
            <p className='amt'>Total</p>
            <p className='amt-val'>{NetAmount.toFixed(2)} /-</p>
          </div>

          {!isConsumerAppointment && scanFeeData && (
            <div className='d-flex justify-content-between align-items-center mb-2'>
              <p className='amt'>Platform Fees</p>
              <p className='amt-val'>{scanFeeData.platformFees.toFixed(2)} /-</p>
            </div>
          )}
          {!isConsumerAppointment && scanFeeData && (
            <div className='d-flex justify-content-between align-items-center mb-2'>
              <p className='amt'>Booking Charges Fees</p>
              <p className='amt-val'>{scanFeeData.bookingCharges.toFixed(2)} /-</p>
            </div>
          )}

          <div className='d-flex justify-content-between align-items-center mb-2'>
            <p className='amt'>Total Payable</p>
            <p className='net-amt-val'>{payableAmount} /-</p>
          </div>
        </div>
      </div>

      <div className='mb-3'>
        <label className='form-label fw-bold'>Test Details</label>
        <ul className='list-group'>
          {testDetails.map((test, idx) => (
            <li key={idx} className='list-group-item d-flex justify-content-between'>
              <span>
                <b>{test.groupName}</b>: {test.testName}
              </span>
              <span>₹{test.testCost}</span>
            </li>
          ))}
        </ul>
      </div>
      {/* <div className="text-end mt-4">
          <button className="ePulse-btn-primary" onClick={() => setIsOpen(true)}>
            Continue
          </button>
        </div> */}
      <div style={{background: '#ffffff'}}>
        <div className='cashin-container'>
          <div className='d-flex flex-column w-50'>
            <p className='mode-text'>
              Order Total Amount : <span>{payableAmount} /-</span>
            </p>
            <span className='form-label'>Payment Mode</span>

            <div className='input-group'>
              <select
                className='form-control px-3'
                value={paymentType}
                onChange={(e) => {
                  setPaymentType(e.target.value)
                }}
              >
                <option value='COMPLETED'>Full Payment</option>
                {/* <option value='PENDING'>Partial Payment</option> */}
              </select>
            </div>
            <span className='form-label'>Cash In</span>
            <div className='input-group'>
              <input
                type='number'
                value={cashIn}
                disabled={paymentType === 'Paid'}
                onChange={(e: any) => setCashIn(e.target.value)}
                className='form-control px-3'
              />
            </div>
            <p className='mode-text'>
              Cash out : <span>{amount.cashOut}</span> <br />
              <span className='cashout-text'>Amount you owes customer</span>
            </p>
            <p className='mode-text'>
              Outstanding Amount : <span>{amount.outstandingAmount}</span> <br />
              <span className='cashout-text'>Amount customer owes you </span>
            </p>
          </div>
          <div className='orientation-container'>
            <p className='mode-text'>
              Payment Mode : <span>Cash</span>
            </p>
            <p className='form-label'>Invoice Orientation</p>
            <div className='input-group'>
              <select
                value={templateSetting.templateOrientation}
                className='form-control px-3'
                onChange={(e) => {
                  setTemplateSetting({
                    ...templateSetting,
                    templateOrientation: e.target.value,
                  })
                }}
              >
                <option value='portrait'>Portrait</option>
                <option value='landscape'>Landscape</option>
              </select>
            </div>
            <p className='form-label'>Invoice Size</p>
            <div className='input-group'>
              <select
                value={templateSetting.templateSize}
                className='form-control px-3'
                onChange={(e) => {
                  setTemplateSetting({
                    ...templateSetting,
                    templateSize: e.target.value,
                  })
                }}
              >
                <option value='A4'>A4</option>
                <option value='A6'>A6</option>
              </select>
            </div>
          </div>
        </div>
        <div className='d-flex justify-content-end'>
          <div className='filter-row ePulse-divider justify-content-end' style={{paddingRight: 20}}>
            <button
              className='ePulse-btn-primary'
              onClick={() => {
                handleCreateAppointmentApiCall()
              }}
            >
              Continue
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ConfirmAppointment
